export { default as TagsMultiSelect } from './TagsMultiSelect';
